import React from 'react'

import { Row, Col, Form } from '_zari/core'

const DiferenciaMontosSection = ({ importeCompraTotalSinIgv, importeSumaTotalPresupuestos }) => {
  return (
    <Row>
      <Col md={6}>
        <Form.Group>
          <Form.Label
            text='IMPORTE PRESUPUESTO'
            htmlFor='movimientoPresupuesto-input-importeSumaTotalPresupuestos'
            md={12}
          />
          <Col md={12}>
            <Form.InputNumber
              id='movimientoPresupuesto-input-importeSumaTotalPresupuestos'
              name='movimientoPresupuesto-input-importeSumaTotalPresupuestos'
              isInvalid={importeCompraTotalSinIgv !== importeSumaTotalPresupuestos}
              disabled
              value={importeSumaTotalPresupuestos}
              onChange={() => {}}
            />
          </Col>
        </Form.Group>
      </Col>
      <Col md={6}>
        <Form.Group>
          <Form.Label
            text='IMPORTE COMPRA/GASTO'
            htmlFor='movimientoPresupuesto-input-importeCompraTotalSinIgv'
            md={12}
          />
          <Col md={12}>
            <Form.InputNumber
              id='movimientoPresupuesto-input-importeCompraTotalSinIgv'
              name='movimientoPresupuesto-input-importeCompraTotalSinIgv'
              // isInvalid={iTouched && iError}
              disabled
              value={importeCompraTotalSinIgv}
              onChange={() => {}}
            />
          </Col>
        </Form.Group>
      </Col>
    </Row>
  )
}

export default React.memo(DiferenciaMontosSection)
